<template>
  <div class="dashboard-brands-and-virtual-tour">
    <div v-if="epwin_system_types.length > 0" class="dashboard-brands-wrapper">
      <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="enquiry_box_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">Thank you for your interest</h1>
          </div>
          <div class="modal-content">
            <div class="form-group">
              Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent a notification when you receive a reply.
            </div>
            <div class="mb-6">
              If you would like to provide some more information you can edit the message below.
            </div>
            <strong class="block pl-2 pb-1">Your Message</strong>
            <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
          </div>
          <div class="modal-footer align-right">
            <a class="btn-primary" @click="sendEnquiry()">
              Send
            </a>
          </div>
        </div>
      </div>
      <div class="modal-window" :class="{'open': acp_enquiry_box_open}" @click="acp_enquiry_box_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="acp_enquiry_box_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">Thank you for your interest</h1>
          </div>
          <div class="modal-content">
            <div class="form-group">
              Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent a notification when you receive a reply.
            </div>
            <div class="mb-6">
              If you would like to provide some more information you can edit the message below.
            </div>
            <strong class="block pl-2 pb-1">Your Message</strong>
            <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
          </div>
          <div class="modal-footer align-right">
            <a class="btn-primary" @click="sendACPEnquiry()">
              Send
            </a>
          </div>
        </div>
      </div>
      <div class="dashboard-epwin-system-types-slider-wrapper">
        <div class="dashboard-epwin-system-types">
          <div class="dashboard-epwin-system-type"
               v-for="(epwin_system_type, index) in epwin_system_types"
               :key="index"
               :class="{ active: index === slider_current_index, inactive: index !== slider_current_index }"
               :data-epwin-system-type-dashboard-slider="epwin_system_type.id" :style="backgroundImage(epwin_system_type.id)">
            <div class="inner-box" v-if="(epwin_system_type.id !== 1 && epwin_system_type.id !== 6)">
              <div class="title">
                {{  epwin_system_type.label }}
              </div>
              <div class="sub-title" v-html="epwin_system_type.description">
              </div>
              <div class="buttons">
                <a class="btn-primary" @click="openEnquiryBox(epwin_system_type)">
                  Send Enquiry
                </a>
              </div>
              <div class="features" v-if="epwin_system_type.id === 4">
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-4-1.png">
                  </div>
                  <div class="label">
                    Strength & Security
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-4-2.png">
                  </div>
                  <div class="label">
                    High Performance
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-4-3.png">
                  </div>
                  <div class="label">
                    Ease of Installation
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-4-4.png">
                  </div>
                  <div class="label">
                    Great Usability
                  </div>
                </div>
              </div>
              <div class="features" v-if="epwin_system_type.id === 7">
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-7-1.png">
                  </div>
                  <div class="label">
                    High performance
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-7-2.png">
                  </div>
                  <div class="label">
                    Full range of ancillaries
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-7-3.png">
                  </div>
                  <div class="label">
                    Effective ventilation
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-7-4.png">
                  </div>
                  <div class="label">
                    Great versatility
                  </div>
                </div>
              </div>
              <div class="features" v-if="epwin_system_type.id === 8">
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-8-1.png">
                  </div>
                  <div class="label">
                    Authentic Proportions
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-8-2.png">
                  </div>
                  <div class="label">
                    Beautiful Options
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-8-3.png">
                  </div>
                  <div class="label">
                    Impressive Performance
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-8-4.png">
                  </div>
                  <div class="label">
                    Valuable Practicality
                  </div>
                </div>
              </div>
              <div class="features" v-if="epwin_system_type.id === 11">
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-11-1.png">
                  </div>
                  <div class="label">
                    Highly specified
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-11-2.png">
                  </div>
                  <div class="label">
                    Strength & security
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-11-3.png">
                  </div>
                  <div class="label">
                    Thermal efficiency
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-11-4.png">
                  </div>
                  <div class="label">
                    Design flexibility
                  </div>
                </div>
                <div class="feature">
                  <div class="img">
                    <img src="images/epwin-system-type-dashboard-feature-img-11-5.png">
                  </div>
                  <div class="label">
                    Committed to sustainability
                  </div>
                </div>
              </div>
            </div>
            <img src="/images/epwin-system-type-dashboard-stellar-banner.png" v-if="epwin_system_type.id === 1" @click="openEnquiryBox(epwin_system_type)" class="cursor-pointer">
            <img src="/images/epwin-system-type-dashboard-safeware-banner.png" v-if="epwin_system_type.id === 6" @click="openEnquiryBox(epwin_system_type)" class="cursor-pointer">
          </div>
          <div class="dashboard-epwin-system-type" data-epwin-system-type-dashboard-slider="acp" :style="backgroundImage('acp')"
               :key="epwin_system_types.length"
               :class="{ active: epwin_system_types.length === slider_current_index, inactive: epwin_system_types.length !== slider_current_index }"
          >
            <img src="/images/epwin-system-type-dashboard-commercial-banner.png" @click="openACPEnquiryBox('acp')" class="cursor-pointer">
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-virtual-tour-wrapper">
      <a href="https://my.matterport.com/show/?m=zy7p3K8x8wA" target="_blank" class="virtual-tour-banner">
        <h3>
          <div>Virtual Showroom Tour</div>
        </h3>
        <div>
          <img src="/images/showroom-tour-dashboard-banner.png">
        </div>
        <h3>
          <div>Explore the Epwin showroom in 3D</div>
        </h3>
      </a>
    </div>
    <div class="slider-nav">
      <div
        v-for="(epwin_system_type, index) in epwin_system_types"
        :key="index"
        class="slider-nav-item"
        :class="{ active: index === slider_current_index }"
        @click="goToSlide(index)"
      ></div>
      <div
        :key="epwin_system_types.length"
        class="slider-nav-item"
        :class="{ active: epwin_system_types.length === slider_current_index }"
        @click="goToSlide(epwin_system_types.length)"
      ></div>
    </div>
  </div>
</template>

<script>

  export default {
    props: [
      'epwin_system_types',
      'logged_in_user',
    ],
    data() {
      return {
        enquiry_box_open: false,
        acp_enquiry_box_open: false,
        selected_epwin_system_type: null,
        sending: false,
        enquiry_message: "",
        slider_current_index: 0,
        slider_timer: null,
      }
    },
    mounted() {
      this.startSlider();
    },
    methods: {
      openACPEnquiryBox() {
        this.enquiry_box_open = false;
        this.enquiry_message = `I would like more information on signing up for the ACP scheme`;
        this.acp_enquiry_box_open = true;
      },
      sendACPEnquiry() {
        this.acp_enquiry_box_open = false;
        this.sending = true;
        axios.post('/enquiry/send', {
          'enquiry_type_id': 21,
          'message': this.enquiry_message,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'Join ACP scheme enquiry',
            'value': 'Join ACP scheme enquiry',
          });

          this.sending = false;
          Swal.fire({
            title: 'Enquiry Sent',
            icon: 'success',
            text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
      openEnquiryBox(epwin_system_type) {
        this.acp_enquiry_box_open = false;
        this.selected_epwin_system_type = epwin_system_type;
        this.enquiry_message = `I am interested in some more information about ${epwin_system_type.label}, thank you.`;
        this.enquiry_box_open = true;
      },
      sendEnquiry() {
        this.enquiry_box_open = false;
        this.sending = true;
        axios.post('/enquiry/send', {
          'enquiry_type_id': this.selected_epwin_system_type.enquiry_type_id,
          'message': `${this.selected_epwin_system_type.label} Enquiry: ${this.enquiry_message}`,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'System type enquiry',
            'value': 'System type enquiry',
          });

          this.sending = false;
          Swal.fire({
            title: 'Enquiry Sent',
            icon: 'success',
            text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
      backgroundImage(id) {
        return { backgroundImage: `url('/images/epwin-system-type-dashboard-slider-background-${id}.png')` };
      },
      startSlider() {
        this.slider_timer = setInterval(() => {
          this.nextSlide();
        }, 5000);
      },
      stopSlider() {
        clearInterval(this.slider_timer);
      },
      nextSlide() {
        this.slider_current_index =
          (this.slider_current_index + 1) % (this.pageLength);
      },
      goToSlide(index) {
        this.slider_current_index = index;
      }
    },
    computed: {
      pageLength() {
        if(this.logged_in_user.isACP) {
          return this.epwin_system_types.length + 1;
        } else {
          return this.epwin_system_types.length
        }
      }
    },
  }
</script>
